// in src/posts.js
import * as React from "react";
import {
  useNotify,
} from "react-admin";
import { FormCountry } from "./FormCountry";
import Edit from "../../baseComponents/Edit";

export const CountryEdit = () => {
  const notify = useNotify();

  const onSuccess = () => {
    notify("ra.action.updated");
  };

  

  return (
    <Edit
      onSuccess={onSuccess}
    >
      <FormCountry></FormCountry>
    </Edit>
  );
};
